import { render, staticRenderFns } from "./Editoras.vue?vue&type=template&id=d083bd32&"
import script from "./Editoras.vue?vue&type=script&lang=js&"
export * from "./Editoras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports